import { Chip, type SxProps, type Theme } from '@mui/material'

import React from 'react'

export type PreviewStatus = 'live' | 'review' | 'draft'

// Which version of an item an admin preview modal is showing. Used by both
// the marketplace and canteen item modals in their preview modes.
const CONFIG: Record<
  PreviewStatus,
  { label: string; color?: 'info' | 'warning'; sx?: SxProps<Theme> }
> = {
  live: { label: 'Live', color: 'info' },
  review: { label: 'In Review', color: 'warning' },
  // No Chip color prop maps to the neutral "action" grey — style it directly.
  draft: { label: 'Draft', sx: { bgcolor: 'action.selected', color: 'text.secondary' } },
}

const PreviewStatusChip: React.FC<{ status: PreviewStatus }> = ({ status }) => {
  const { label, color, sx } = CONFIG[status]
  return <Chip size="small" label={label} color={color} sx={sx} />
}

export default PreviewStatusChip
